import type { UserAdmin } from '@tt/shared';

/**
 * Why "Reset password" cannot be used on a row, as a translation key — or `undefined` when it can.
 *
 * Every rule here mirrors a guard in the API's `AdminUsersService.resetPassword`, which is what
 * actually enforces them; these exist so the answer arrives before the click rather than as a 409
 * afterwards. They are evaluated in the server's order, so the two can never disagree about which
 * rule was the one that applied.
 *
 * It returns a key rather than a sentence so that the rule can be tested without a translator,
 * and so the wording stays in `i18n/en.json` with every other string.
 */
export function resetPasswordBlocker(
  user: Pick<UserAdmin, 'status' | 'anonymizedAt'>,
  isSelf: boolean,
): string | undefined {
  if (isSelf) return 'admin.users.notYourself';
  // An invited user has never had a password, so there is nothing to reset. The invitation is the
  // thing that sets one, and re-sending it is offered in the same menu.
  if (user.status === 'INVITED') return 'admin.users.resetPasswordInviteFirst';
  if (user.anonymizedAt !== null) return 'admin.users.resetPasswordAnonymized';
  return undefined;
}
